import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.card)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h1", null, "🌱" + _toDisplayString(_ctx.card.title) + "🌱", 1),
          _createElementVNode("img", {
            src: _ctx.card.image,
            alt: _ctx.card.title
          }, null, 8, _hoisted_2),
          _createElementVNode("h3", null, [
            _cache[0] || (_cache[0] = _createElementVNode("strong", null, "🗓️Date :", -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.card.date), 1)
          ]),
          _createElementVNode("h3", null, [
            _cache[1] || (_cache[1] = _createElementVNode("strong", null, "📍Lieu :", -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.card.location), 1)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[2] || (_cache[2] = [
          _createElementVNode("p", null, "Carte introuvable 🫤", -1)
        ]))),
    _createVNode(_component_ButtonComponent, {
      label: "Retour à la collection",
      to: "/collection"
    })
  ], 64))
}